import { mode, transparentize } from '@chakra-ui/theme-tools';
const parts = ['root', 'tablist', 'tab', 'tabpanel', 'indicator'];
function baseStyleTab(props) {
    const { isFitted } = props;
    return {
        flex: isFitted ? 1 : undefined,
    };
}
function baseStyleTablist(props) {
    const { align = 'start', orientation } = props;
    const alignments = {
        end: 'flex-end',
        center: 'center',
        start: 'flex-start',
    };
    return {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        justifyContent: alignments[align],
        flexDirection: orientation === 'vertical' ? 'column' : 'row',
    };
}
function baseStyleRoot() {
    return {
        pos: 'relative',
    };
}
const baseStyle = (props) => {
    return {
        root: baseStyleRoot(),
        tab: baseStyleTab(props),
        tablist: baseStyleTablist(props),
    };
};
function variantLine(props) {
    const { theme, orientation } = props;
    const borderProp = orientation === 'vertical' ? 'borderLeft' : 'borderBottom';
    return {
        tablist: {
            [borderProp]: '1px solid',
            borderColor: 'inherit',
        },
        tab: {
            mb: 2,
            marginX: '0.375rem',
            paddingY: '0.1875rem',
            paddingX: 6,
            borderRadius: 'base',
            whiteSpace: 'nowrap',
            lineHeight: '1.625rem',
            border: 'none',
            _selected: {
                fontWeight: 'semibold',
                color: mode('gray.600', 'white')(props),
            },
            _focus: {
                bg: 'transparent',
                boxShadow: mode(`0 0 0 1px ${transparentize(`blue.600`, 1.0)(theme)}, 0 0 0 5px ${transparentize(`blue.400`, 0.24)(theme)}`, `0 0 0 1px ${transparentize(`blue.300`, 1.0)(theme)}, 0 0 0 5px ${transparentize(`blue.400`, 0.24)(theme)}`)(props),
            },
            ':focus:not(:focus-visible)': {
                boxShadow: 'none',
            },
            ':focus:not(:-moz-focusring)': {
                boxShadow: 'none',
            },
            _hover: {
                bg: transparentize(`blue.300`, 0.12)(theme),
                color: mode('gray.600', 'white')(props),
                _active: {
                    bg: transparentize(`blue.300`, 0.24)(theme),
                },
            },
            _disabled: {
                cursor: 'not-allowed',
            },
        },
        tabpanel: {
            p: 4,
        },
        indicator: {
            mt: -1,
            height: 1,
            bg: mode('blue.500', 'blue.400')(props),
            borderRadius: '4px 4px 0px 0px',
            position: 'absolute',
        },
    };
}
const variants = {
    line: variantLine,
};
const defaultProps = {
    variant: 'line',
    colorScheme: 'blue',
};
export default {
    parts,
    baseStyle,
    variants,
    defaultProps,
};
//# sourceMappingURL=tabs.js.map